import { serviceProvider } from '@yola/subscription-manager-js';
import { errors } from '@yola/ws-sdk';
import setLoadingStatus from '../actions/set-loading-status';

const fetchSubscriptions = () => async (dispatch) => {
  try {
    await serviceProvider.fetchSubscriptions();
    dispatch(setLoadingStatus(true));
  } catch (error) {
    errors.operations.catchError(error);
  }
};

export default fetchSubscriptions;
